import {Box} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import SearchInput from "crqlar-react-common/dist/components/CList/SearchInput";
import {
    useCurrentAppId
} from "crqlar-react-common/dist/utils/hooks/app/useOrganizationApps";
import {
    ReservationActions,
    useReservationsState
} from "../../../../../store/reservations.reducer";

const ReadSidebarSearch: React.FC = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const appId = useCurrentAppId();
    const {searchQuery} = useReservationsState(appId);

    const searchBarOpenTriggered = useSelector((state: any) => state.action.searchBarTriggered);

    return (
        <Box
            sx={{
                display: searchBarOpenTriggered ? "flex" : "none",
                height: 60,
                width: "100%",
                px: 1,
                boxSizing: "border-box",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Box sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                height: "100%",
                minWidth: 0,
                "& .MuiTextField-root": {
                    width: "100% !important",
                },
            }}>
                <SearchInput
                    initialQuery={searchQuery || ""}
                    placeholder={t("Search")}
                    onSearch={(value) => {
                        dispatch({
                            type: ReservationActions.SET_RESERVATIONS,
                            appId,
                            payload: {
                                searchQuery: value?.trim() || undefined,
                            },
                        });
                    }}
                    forceExpand={searchBarOpenTriggered}
                    rightHandSideSearch={true}
                    searchSidebarTrigger={searchBarOpenTriggered}
                    textFieldSize={320}
                    debounceTime={500}
                />
            </Box>
        </Box>
    );
};

export default ReadSidebarSearch;
